import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PanoramaIcon from "@mui/icons-material/Panorama";
import Support from "@mui/icons-material/Support";
import Payments from "@mui/icons-material/Payments";
import NotesIcon from "@mui/icons-material/Notes";
import UploadIcon from "@mui/icons-material/Upload";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import GradeIcon from "@mui/icons-material/Grade";
import DashboardLayout from "../components/common/DashboardLayout";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import MemoryIcon from "@mui/icons-material/Memory";
import AddAlertIcon from "@mui/icons-material/AddAlert";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import InsightsIcon from "@mui/icons-material/Insights";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import DatasetLinkedIcon from "@mui/icons-material/DatasetLinked";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import CellTowerIcon from "@mui/icons-material/CellTower";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import WidgetsIcon from "@mui/icons-material/Widgets";
import StyleIcon from "@mui/icons-material/Style";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";

const mainListItemsArray = [
  {
    id: 1,
    label: "Mid/Long Term (Equity)",
    link: "/advisor/advisory-form",
    icon: <Support />,
  },
  {
    id: 2,
    label: "Premium Research Calls",
    link: "/advisor/trade-calls?activeTab=cash",
    icon: <Payments />,
  },
  {
    id: "2-1",
    label: "Basket",
    link: "/advisor/basket",
    icon: <ShoppingBasketIcon />,
  },

  // {
  //   id: 11,
  //   label: "Broker Access",
  //   link: "/advisor/broker-access",
  //   icon: <ShowChartIcon />,
  // },
  {
    id: 3,
    label: "Options Dashboard",
    icon: <CandlestickChartIcon />,
    children: [
      {
        id: "5-1",
        label: "Dashboard Home",
        link: "/advisor/options-dashboard",
        icon: <CandlestickChartIcon />,
      },
      {
        id: "5-2",
        label: "Option Disclaimer",
        link: "/advisor/options-dashboard/disclaimer",
        icon: <NotesIcon />,
      },
    ],
  },
  {
    id: 4,
    label: "Trading Activity",
    link: "/advisor/trading-activity",
    icon: <InsightsIcon />,
  },
  {
    id: 5,
    label: "Broker Trade",
    icon: <ShowChartIcon />,
    children: [
      {
        id: "12-1",
        label: "Trade Dashboard",
        link: "/advisor/broker-trade/trade-dashboard",
        icon: <ShowChartIcon />,
      },
      {
        id: "12-2",
        label: "Trade Dashboard Symbolwise",
        link: "/advisor/broker-trade/trade-dashboard-symbolwise",
        icon: <ShowChartIcon />,
      },
      {
        id: "12-4",
        label: "Symbolwise Drilldown",
        link: "/advisor/broker-trade/trade-dashboard-symbolwise-drilldown",
        icon: <CandlestickChartIcon />,
      },
      {
        id: "12-3",
        label: "Open Trade",
        link: "/advisor/broker-trade/open-trade",
        icon: <ShowChartIcon />,
      },
    ],
  },

  {
    id: 7,
    label: "Alerts Managements",
    icon: <ManageHistoryIcon />,
    children: [
      {
        id: "7-1",
        label: "All Alerts",
        link: "/advisor/alerts-managements/all-alerts",
        icon: <AddAlertIcon />,
      },
      {
        id: "7-2",
        label: "Alerts-Stockyaari",
        link: "/advisor/alerts-managements/alerts-stockyaari",
        icon: <PersonAddIcon />,
      },
      {
        id: "7-3",
        label: "Signals-Dashboard",
        link: "/advisor/alerts-managements/signals-dashboard",
        icon: <DatasetLinkedIcon />,
      },
      {
        id: "7-4",
        label: "Stock Alerts",
        link: "/advisor/stock-alerts",
        icon: <HowToRegIcon />,
      },
    ],
  },
  {
    id: 8,
    label: "Notifications & Engagement",
    icon: <NotificationsActiveIcon />,
    children: [
      {
        id: "8-1",
        label: "Push Notifications",
        link: "/advisor/push-notifications",
        icon: <InsightsIcon />,
      },
      {
        id: "8-2",
        label: "One Signals",
        link: "/advisor/one-signals",
        icon: <CellTowerIcon />,
      },
      // {
      //   id: "8-3",
      //   label: "User Rating",
      //   link: "/advisor/user-rating",
      //   icon: <GradeIcon />,
      // },
      {
        id: "8-4",
        label: "User Support",
        link: "/advisor/user-support",
        icon: <SupportAgentIcon />,
      },
      // {
      //   id: "8-5",
      //   label: "Invoice",
      //   link: "/advisor/invoice-dashboard",
      //   icon: <ReceiptLongIcon />,
      // },
      {
        id: "8-6",
        label: "Customer Info",
        link: "/advisor/customer-info",
        icon: <SupportAgentIcon />,
      },
      // {
      //   id: "8-7",
      //   label: "Profit Cards",
      //   link: "/advisor/profit-cards",
      //   icon: <StyleIcon />,
      // },
    ],
  },



  // {
  //   id: 10,
  //   label: "News",
  //   link: "/advisor/news",
  //   icon: <NewspaperIcon />,
  // },



  // {
  //   id: 6,
  //   label: "Add Carousel",
  //   link: "/advisor/banner",
  //   icon: <PanoramaIcon />,
  // },
  // {
  //   id: 7,
  //   label: "Create Ticker",
  //   link: "/advisor/create-ticker",
  //   icon: <NotesIcon />,
  // },
  {
    id: 8,
    label: "Home Screen Configuration",
    icon: <SettingsSuggestIcon />,
    children: [
      {
        id: "8-1",
        label: "Upload Banners",
        link: "/advisor/home-screen-configuration/upload-banners",
        icon: <UploadIcon />,
      },
      {
        id: "8-2",
        label: "App Configuration",
        link: "/advisor/home-screen-configuration/app-configuration",
        icon: <MemoryIcon />,
      },
    ],
  },

  // {
  //   id: 9,
  //   label: "Misc",
  //   icon: <WidgetsIcon />,
  //   children: [
  //     {
  //       id: "9-1",
  //       label: "Subscription-Visit",
  //       link: "/advisor/user-subscription-history",
  //       icon: <RecentActorsIcon />,
  //     },
  //     {
  //       id: "9-10",
  //       label: "Performance Cards",
  //       link: "/advisor/performance-cards",
  //       icon: <InsightsIcon />,
  //     },
  //     {
  //       id: "9-2",
  //       label: "Intro Screens",
  //       link: "/advisor/intro-screens",
  //       icon: <SmartphoneIcon />,
  //     },
  //     {
  //       id: "9-3",
  //       label: "Futures",
  //       link: "/advisor/futures",
  //       icon: <CandlestickChartIcon />,
  //     },
  //   ],
  // },
];

export default function AdvisorDashboardLayout() {
  return <DashboardLayout mainListItems={mainListItemsArray} />;
}
